// components/icons/StarIcon.tsx

interface StarIconProps {
  index: number;
  fillPercentage: number;
}
const SvgEstrellas: React.FC<StarIconProps> = ({ index, fillPercentage }) => {
  const safePercentage =
    typeof fillPercentage === "number" && !isNaN(fillPercentage)
      ? Math.max(0, Math.min(100, fillPercentage))
      : 0;

  const borderClass =
    safePercentage > 0
      ? 'border-yellow-400 border-r-2 border-t-2'
      : 'border-transparent';

  return (
    <svg
      key={index}
      viewBox="0 0 24 24"
      width="32"
      height="32"
      className={`mx-0.5 bg-slate-700 rounded-md p-1 ${borderClass}`}
    >
      <defs>
        <clipPath id={`clip-${index}`}>
          <rect x="0" y="0" width={`${safePercentage}%`} height="100%" />
        </clipPath>
      </defs>

      <path
        d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
        fill="#E4E4E7"
        stroke={safePercentage > 0 ? 'gold' : 'gray'}
        strokeWidth="1"
      />

      <path
        d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
        fill="gold"
        clipPath={`url(#clip-${index})`}
      />
    </svg>
  );
};

export default SvgEstrellas;
